
import React from "react";
import RoomFeatureListTable from "./Componates/RoomFeatureListTable";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from "Common/Custom/AddItemBtn";

const RoomFeatureList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Room Feature List</HeadingOne>
          <AddItemBtn url="add-room-features" title="Add Room Feature" />
        </>
      }
    >
      <div className="col-12">
        <RoomFeatureListTable />
      </div>
    </PageBody>
  );
};

export default RoomFeatureList;
